module.exports = __webpack_public_path__ + "static/media/downloadLogo.5b35004e.webp";